// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"340":"070e8143","476":"070e8143","704":"070e8143","736":"84dd86a1","799":"dd4e4819"}[chunkId] + ".css";
};